export const HIDE_MODAL = 'HIDE_MODAL';
export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_FORM_SECTION = 'HIDE_FORM_SECTION';
export const SHOW_FORM_SECTION = 'SHOW_FORM_SECTION';

export const HIDE_ALERT = 'HIDE_ALERT';
export const SHOW_ALERT = 'SHOW_ALERT';

export const ALERT_INNER_MODAL = 'ALERT_INNER_MODAL';
export const ALERT_TOP_MODAL = 'ALERT_TOP_MODAL';

export const ACTIVATE_TAB = 'ACTIVATE_TAB';
export const TAB_ACTIVITY = 'TAB_ACTIVITY';
export const TAB_SUMMARY = 'TAB_SUMMARY';

export const ALERT_DASHBOARD_INCOMPLETE_AFTER_REMOVE = 'ALERT_DASHBOARD_INCOMPLETE_AFTER_REMOVE';
export const ALERT_DASHBOARD_ORGANIZER_COVERED_SHARES = 'ALERT_DASHBOARD_ORGANIZER_COVERED_SHARES';
export const ALERT_DASHBOARD_MEMBERS_INVITED = 'ALERT_DASHBOARD_MEMBERS_INVITED';
export const ALERT_DASHBOARD_MEMBERS_REMOVED = 'ALERT_DASHBOARD_MEMBERS_REMOVED';
export const ALERT_DASHBOARD_AUTO_PILOT_DISABLED = 'ALERT_DASHBOARD_AUTO_PILOT_DISABLED';
export const SET_COMMIT_FORM_VERSION = 'SET_COMMIT_FORM_VERSION';
export const ALERT_DASHBOARD_REMINDERS_SENT = 'ALERT_DASHBOARD_REMINDERS_SENT';
export const ALERT_ACCOUNT_UPDATED = 'ALERT_ACCOUNT_UPDATED';
export const ALERT_ACCOUNT_UPDATE_ERROR = 'ALERT_ACCOUNT_UPDATE_ERROR';
export const ALERT_RECOVER_PASSWORD_SENT = 'ALERT_RECOVER_PASSWORD_SENT';
export const ALERT_SET_NEW_PASSWORD_ERROR = 'ALERT_SET_NEW_PASSWORD_ERROR';
export const ALERT_MUST_LOG_IN_TO_INVITE = 'ALERT_MUST_LOG_IN_TO_INVITE';
export const ALERT_PURCHASE_SAVED = 'ALERT_PURCHASE_SAVED';
export const ALERT_WITHDRAW_FROM_PURCHASE = 'ALERT_WITHDRAW_FROM_PURCHASE';

export const MOBILE_UPDATE_CLAIM_STEP = 'MOBILE_UPDATE_CLAIM_STEP';
export const MOBILE_MODAL = 'mobileModal';

export const AUTOPILOT_MODAL = 'autoPilot';
const INVITE_MODAL = 'invite';
const INVITE_CONFIRMATION_MODAL = 'inviteConfirmation';
const IMAGE_MAGNIFIER_MODAL = 'imageMagnifier';
const MAKE_CHANGES_MODAL = 'makeChanges';
const RESOLVE_ISSUES_MODAL = 'resolveIssues';
const DUPLICATED_PURCHASE_MODAL = 'duplicatedPurchase';
const CANCEL_PURCHASE_MODAL = 'cancelPurchase';
const COMMIT_MODAL = 'commit';
const EDIT_COMMIT_MODAL = 'editCommit';
const COVER_DIFFERENCE_MODAL = 'coverDifference';
const WITHDRAW_MODAL = 'withdraw';
const REMOVE_MODAL = 'remove';
const PAYMENT_SENT_MODAL = 'paymentSent';


export const POST_CLAIM_COMMIT = 'post-claim';
export const DASHBOARD_COMMIT = 'dashboard';

export const SIGNIN_FORM_SECTION = 'signin';
export const SIGNUP_FORM_SECTION = 'signup';

export const hideSigninFormSection = () => ({ type: HIDE_FORM_SECTION, payload: SIGNIN_FORM_SECTION });
export const showSigninFormSection = () => ({ type: SHOW_FORM_SECTION, payload: SIGNIN_FORM_SECTION });
export const hideSignupFormSection = () => ({ type: HIDE_FORM_SECTION, payload: SIGNUP_FORM_SECTION });
export const showSignupFormSection = () => ({ type: SHOW_FORM_SECTION, payload: SIGNUP_FORM_SECTION });

export const activateTab = (tabName) => {
  return {
    type: ACTIVATE_TAB,
    payload: { tabName },
  };
}

export const showModal = (name, config = {}) => {
  return {
    type: SHOW_MODAL,
    payload: {
      ...config,
      name,
    },
  };
};

export const hideModal = (name, config = {}) => {
  return {
    type: HIDE_MODAL,
    payload: {
      ...config,
      name,
    },
  };
};

export const showMobileModal = (name, config = {}) => {
  return showModal(MOBILE_MODAL, {
    ...config,
    activeModal: name,
  });
};
export const hideMobileModal = (name) => hideModal(MOBILE_MODAL);

export const hideAutoPilotModal = (purchaseId) => {
  return hideModal(AUTOPILOT_MODAL, { purchaseId });
};

export const showAutoPilotModal = () => showModal(AUTOPILOT_MODAL);

export const hideInviteModal = () => hideModal(INVITE_MODAL);
export const showInviteModal = () => showModal(INVITE_MODAL);

export const hideInviteConfirmationModal = () => hideModal(INVITE_CONFIRMATION_MODAL);
export const showInviteConfirmationModal = () => showModal(INVITE_CONFIRMATION_MODAL);

export const hideImageMagnifierModal = () => hideModal(IMAGE_MAGNIFIER_MODAL);
export const showImageMagnifierModal = () => showModal(IMAGE_MAGNIFIER_MODAL);

export const hideMakeChangesModal = () => hideModal(MAKE_CHANGES_MODAL);
export const showMakeChangesModal = (options = {}) => showModal(MAKE_CHANGES_MODAL, options);

export const hideResolveIssuesModal = () => hideModal(RESOLVE_ISSUES_MODAL);
export const showResolveIssuesModal = () => showModal(RESOLVE_ISSUES_MODAL);

export const hideDuplicatedPurchaseModal = () => hideModal(DUPLICATED_PURCHASE_MODAL);
export const showDuplicatedPurchaseModal = () => showModal(DUPLICATED_PURCHASE_MODAL);

export const hideCancelPurchaseModal = () => hideModal(CANCEL_PURCHASE_MODAL);
export const showCancelPurchaseModal = () => showModal(CANCEL_PURCHASE_MODAL);

export const hideCommitModal = () => hideModal(COMMIT_MODAL);
export const showCommitModal = (options = {}) => showModal(COMMIT_MODAL, options);

export const hideEditCommitModal = () => hideModal(EDIT_COMMIT_MODAL);
export const showEditCommitModal = (options = {}) => showModal(EDIT_COMMIT_MODAL, options);

export const hideCoverDifferenceModal = () => hideModal(COVER_DIFFERENCE_MODAL);
export const showCoverDifferenceModal = (options = {}) => showModal(COVER_DIFFERENCE_MODAL, options);

export const hideWithdrawModal = () => hideModal(WITHDRAW_MODAL);
export const showWithdrawModal = () => showModal(WITHDRAW_MODAL);

export const hideRemoveModal = () => hideModal(REMOVE_MODAL);
export const showRemoveModal = (options = {}) => showModal(REMOVE_MODAL, options);

export const hidePaymentSentModal = () => hideModal(PAYMENT_SENT_MODAL);
export const showPaymentSentModal = (options = {}) => showModal(PAYMENT_SENT_MODAL, options);

export const showAlert = (name, config = {}) => {
  window.scrollTo(0, 0);

  return {
    type: SHOW_ALERT,
    payload: {
      ...config,
      name,
    },
  };
};

export const hideAlert = (name) => {
  return {
    type: HIDE_ALERT,
    payload: {
      name,
    },
  };
};

export const showModalInnerAlert = (content, type = 'warning') => {
  return showAlert(ALERT_INNER_MODAL, { content, type });
};

export const hideModalInnerAlert = () => hideAlert(ALERT_INNER_MODAL);

export const showModalTopAlert = (content, type = 'success') => {
  return showAlert(ALERT_TOP_MODAL, { content, type });
};

export const hideModalTopAlert = () => hideAlert(ALERT_TOP_MODAL);

export const setCommitFormVersion = (name) => {
  return {
    type: SET_COMMIT_FORM_VERSION,
    payload: { name },
  };
};

export const updateClaimStep = (step) => {
  return {
    type: MOBILE_UPDATE_CLAIM_STEP,
    payload: { step },
  };
};



// WEBPACK FOOTER //
// ./src/actions/ui.js